import {NameValueCodeDTO} from '../../../common/models/NameValueCodeDTO';
import {BaseDTO} from '../../../common/models/BaseDTO';

export class RemunerationDTO extends BaseDTO {
  remunerationId: number;
  amount: number;
  period: NameValueCodeDTO;
  startDate: Date;
  endDate: Date;
}
